import React, { useState, useRef, useEffect } from 'react';
import { times } from 'lodash-es';

const useFillUpRow = (reportsCount, {
  minWidthCard = 345,
  sidePaddingValue = 64,
} = {}) => {
  const { current: container } = useRef(document.querySelector('.use-fillup-row-container'));

  const countAdditionalCards = () => {
    if (!container) return 0;

    const containerWidth = container.offsetWidth - sidePaddingValue;
    const rowSize = Math.floor(containerWidth / minWidthCard);
    if (rowSize >= reportsCount) return 0;

    const rowsCount = Math.ceil(reportsCount / rowSize);
    const maxCardsCount = rowSize * rowsCount;
    return maxCardsCount > reportsCount ? maxCardsCount - reportsCount : 0;
  };

  const [additionalCardsCount, setAdditionalCardsCount] = useState(countAdditionalCards());

  useEffect(() => {
    const handleChangeCountCards = () => setAdditionalCardsCount(countAdditionalCards());
    window.addEventListener('resize', handleChangeCountCards);
    return () => {
      window.removeEventListener('resize', handleChangeCountCards);
    };
  }, []);

  return additionalCardsCount > 0 ? times(additionalCardsCount).map(n => <div key={n} className="fillup-row-item" />) : null;
};

export default useFillUpRow;
